export default {
  translation: {
    OpenApp: "حل التطبيق",
    FAQ: "الأسئلة الشائعة",
    AboutUs: "علينا",
    Tutorials: "الدروس",
    Blog: "البلوك",
    MyPlansTitle: "الباقات ديالي",
    MyPlansDescription:
      "تقدر تشوف لائحة الباقات اللي نقدر نصممها ليك فهاد القسم. خاصك تعرف بلي هاد الباقات ما تحضراتش مسبقا وهي مصممة على حسب الحالة البدنية ديالك والهدف ديالك. تقدر تتواصل معايا من خلال زر الشات فالبروفايل ديالي من بعد ما تنصب تطبيق رامبودي.",
    ExpertiseTitle: "الخبرة ديالي",
    AboutMeTitle: "نظرة عامة عليا",
    DownloadApps: "حمل التطبيق",
    DownloadApps_sharelink: "1. حمل التطبيق",
    DownloadDescription: "",
    TutorialVideo: "الدروس",
    TutorialVideoDescription:
      "شوف الفيديوهات التعليمية هنا باش تستعمل التطبيق مزيان وتعرف كيفاش تصمم خطط التدريب.",
    CompanyDescription:
      "رامبودي هي منصة تواصل بين المدربين والمتدربين باش توفر خطة تدريب وتغذية مخصصة.",
    AllRightsReserved: "جميع الحقوق محفوظة 2019. شركة فاروسا للتقنيات.",
    CompanyName: "شركة فاروسا للتقنيات",
    Level: "المرحلة",
    HowToApplyProgram: "كيفاش نقدر نطلب باقة؟",
    ApplyProgramLevel1: "حمل تطبيق رامبودي",
    ApplyProgramLevel2: "قلب على الرقم ديالي ({0}) فالتطبيق",
    ApplyProgramLevel3: "طلب وحدة على حسب الحاجة والهدف ديالك",
    ApplyProgramLevel4: "صمم وابعث الطلب فالوقت المحدد",
    Close: "سد",
    ReadMore: "المزيد",
    Less: "أقل",
    experimental: "تجريبي",
    expert: "خبير",
    amateur: "هاوي",
    totalSentPlans: "مجموع الخطط المرسلة",
    download: "حمل رامبودي",
    requestPackage: "طلب خطة",
    info1: "2. سجل فالتطبيق",
    info2: "3. رجع لهاد الصفحة",
    info3: "4. كليك على الزر لتحت",
    redirectingToApp: "كنحاول نحل تطبيق رامبودي...",
    ifNotRedirected: "ما عندكش التطبيق؟ غادي ندوزك للتحميل دابا.",
  },
};
